import React, { useEffect, useState } from 'react';

type Star = {
  id: string;
  size: number;
  left: number;
  top: number;
  duration: number;
};

export default function NotReadyYet() {
  const [stars, setStars] = useState<Star[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const id = Math.random().toString(36).substr(2, 9);
      const size = Math.random() * 4 + 2;
      const left = Math.random() * 100;
      const top = Math.random() * 100;
      const duration = Math.random() * 1.5 + 1;

      setStars(prev => [...prev, { id, size, left, top, duration }]);

      setTimeout(() => {
        setStars(prev => prev.filter(s => s.id !== id));
      }, duration * 1000);
    }, 400);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.centerContent}>
        <div style={styles.text}>
          Der Dino arbeitet noch am letzten Feinschliff. 💻🦖
        </div>
      </div>

      {stars.map(star => (
        <div
          key={star.id}
          style={{
            ...styles.star,
            width: star.size,
            height: star.size,
            left: `${star.left}%`,
            top: `${star.top}%`,
            animation: `blink ${star.duration}s ease-in-out`,
          }}
        ></div>
      ))}

      <style>{`
        @keyframes blink {
          0%, 100% { opacity: 0; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    position: 'relative' as const,
    width: '70vw',
    height: '80vh',
    background: 'transparent',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  centerContent: {
    position: 'relative' as const,
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
  },
  dino: {
    width: '150px',
    height: 'auto',
    filter: 'invert(0)', // schwarz lassen
  },
  text: {
    marginTop: '10px',
    fontSize: '1.6rem',
    fontWeight: 'bold' as const,
    color: 'black',
  },
  star: {
    position: 'absolute' as const,
    backgroundColor: 'black',
    borderRadius: '50%',
    zIndex: 1,
  },
};
